import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { EncryptedLoginComponent, LoginForm } from "../components/auth";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Login() {
  const searchParams = useQuery();
  const emailId = searchParams.get("email");
  const name = searchParams.get("name");

  const router = useNavigate();
  const [isEmailLink, setIsEmailLink] = useState(false);
  const [isNameLink, setIsNameLink] = useState(false);

  // useEffect(() => {
  //   if (emailId) {
  //     setIsEmailLink(true);
  //   }
  //   if (name) {
  //     setIsNameLink(true);
  //   }

  //   if (router.isReady) {
  //     const hasEmailAndNameParams =
  //       typeof router.query.email === "string" &&
  //       typeof router.query.name === "string";
  //     setIsEmailLink(hasEmailAndNameParams);
  //   }
  // }, [router.isReady, emailId, name, router.query.email, router.query.name]); // Include router.query.email and router.query.name in the dependency array

  return <>{isEmailLink ? <EncryptedLoginComponent /> : <LoginForm />}</>;
}

export default Login;
